import { render, staticRenderFns } from "./tableLuarRadius.vue?vue&type=template&id=fc2bbaa6&scoped=true"
import script from "./tableLuarRadius.vue?vue&type=script&lang=js"
export * from "./tableLuarRadius.vue?vue&type=script&lang=js"
import style0 from "./tableLuarRadius.vue?vue&type=style&index=0&id=fc2bbaa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2bbaa6",
  null
  
)

export default component.exports